import get from 'lodash/get';
import { createModuleDescriptor } from '../../redux/module-descriptor';
import { createUploadDescriptor } from '../../redux/upload-descriptor';
import entities from './entities';
import actions from './actions';
import reducer from './reducer';
import saga from './sagas';
import selectors from './selectors';
import * as helpers from './helpers';

export default createModuleDescriptor('products', {
  entities: Object.values(entities),
  actions,
  reducer,
  saga,
  selectors,
  helpers,
  uploads: [
    createUploadDescriptor(
      'itemImageUpload',
      {
        url: '/api/items/${itemId}/assets.json',
      },
      Object.values(entities)
    ),
  ],
  autocomplete: [
    {
      name: 'category',
      url: '/api/categories.json',
      timeToLive: 15 * 60000,
      getId: entry => entry.id,
      getLabel: (entry, locale) =>
        get(
          entry.name.find(n => n.lang === locale),
          'name'
        ),
    },
    {
      name: 'brand',
      url: '/api/brands.json',
      timeToLive: 15 * 60000,
      getId: entry => entry.id,
      getLabel: entry => entry.name,
    },
    {
      name: 'model',
      url: '/api/models.json',
      timeToLive: 15 * 60000,
      getId: entry => entry.id,
      getLabel: entry => entry.name,
    },
  ],
});
